export const getLLTtoken = () => {
  
  if(import.meta.env.VITE_LOCAL_LLT) {
    return import.meta.env.VITE_LOCAL_LLT
  }

  return document.cookie
    ?.split("; ")
    ?.find((c) => c.includes("llt"))
    ?.split("=")[1];
};
